import { render } from "./OrgRequestsView.vue?vue&type=template&id=2ad98d80"
import script from "./OrgRequestsView.vue?vue&type=script&lang=js"
export * from "./OrgRequestsView.vue?vue&type=script&lang=js"

import "./OrgRequestsView.vue?vue&type=style&index=0&id=2ad98d80&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__